import { Component, OnInit, Inject, ViewEncapsulation, NgZone }  from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { Router } from '@angular/router';
import moment from 'moment';

/**
 * 休み種別
 */
export const HOLDAY_TYPE = [
  { key: 0, val: '休み' },
  { key: 1, val: '有休' },
  { key: 2, val: '欠員' },
  { key: 5, val: '要確認' },
  { key: 6, val: '指定有休' },
  { key: 7, val: '振替（休み）' },
  { key: 8, val: '有休（半日）' },
  { key: 9, val: '振替（有休）' },
  { key: 10, val: '振替（半有休）' },
  { key: 11, val: '振替（欠員）' },
  { key: 12, val: '短時間（早退など）' },
]

export const EXCHANGE_STATUS = [7, 9, 10, 11]

@Component({
  selector: 'app-holiday-dialog',
  templateUrl: './holiday-dialog.component.html',
  styleUrls: ['./holiday-dialog.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class HolidayDialogComponent implements OnInit {

  headers = new HttpHeaders({
    'X-LoginAccessKey': localStorage.getItem('accessKey')
  });

  start: Date = new Date();

  end: Date = new Date();

  saving = false;

  // 保存するデータ
  list = []

  // 一覧の作り直し（formatList）を呼んだ回数。続けて呼ばれたとき、最後の呼び出しかどうかを見分けるのに使う
  formatSeq = 0

  // 休み種別ドロップダウン
  // 短時間（早退など。status 12）は未リリースなので新しく選べない。使うときは下の行のコメントを外すだけ（計算・表示は残してある）。登録済みの日だけ、日ごとのドロップダウンに出す
  statusChoices = [
    { key: 0, value: '休み' },
    { key: 1, value: '有休' },
    { key: 8, value: '有休（半日）' },
    { key: 2, value: '欠員' },
    { key: 5, value: '要確認' },
    { key: 6, value: '指定有休' },
    // { key: 12, value: '短時間（早退など）' },
  ];

  // 休み種別（一括変更）
  status = null;

  // 通常メモ
  note = '';

  // 録音メモ
  note2 = '';

  // 画面上半分に表示するデータ
  value = {};

  // 担当物件
  siteList = [{ sequenceNumber: '', cdSite: '', cdContract: '', nameSite: '', target: [{ day: '', hours: null, minutes: null, workingHours: null, start: null, end: null }]}];

  // 画面表示　初期値：連日
  displaySpecifyDate = 'consecutive';

  // 複数日選択
  daysSelected: any[] = [];

  // 選択した日（表示用）
  days:string = '';

  // 曜日ドロップダウン
  weekly = [
    {key: 1, value: '月曜日'},
    {key: 2, value: '火曜日'},
    {key: 3, value: '水曜日'},
    {key: 4, value: '木曜日'},
    {key: 5, value: '金曜日'},
    {key: 6, value: '土曜日'},
    {key: 0, value: '日曜日'}
  ];

  // 選択した曜日
  week = [];

  // 有休時間一括設定用
  setHours: number = 0;
  setMinutes: string = '00';

  // 時間のドロップダウン
  hours: number[] = this.generateNums(12);
  minutes: string[] = [ '00', '25', '5', '75' ];

  // 有休残数
  paidHolidayLeft: string;
  // 登録済みの有休利用日
  // paidHolidayDays = [];
  // 代勤の最終更新者
  operationCreatedUser = '';
  // 代勤の最終更新日
  operationCreatedDate = '';
  // 休みの登録者
  statusInsertedUser = '';
  // 休みの登録日
  statusInsertedDate = '';
  // 休みの最終更新者
  statusUpdateUser = '';
  // 休みの最終更新日
  statusUpdateDate = '';

  // tbl_operation_noteに保存するデータ
  operationNote: any[] = [];

  // 録音タスク登録するか否か
  isRecord = true;
  // 復帰確認タスク
  isReturnTask = false;
  // 勤務日のみ
  isOnlyWorkingDays = false;

  nowLoading = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<HolidayDialogComponent>) { }

  async ngOnInit() {
    // 録音タスク対象者か判定
    const dep = localStorage.getItem('departmentName')
    // 建物管理部もしくは勤怠採用、もしくは品管は録音タスク不要
    if (dep && (dep.indexOf('建物管理') > -1 || dep.indexOf('勤怠採用') > -1 || dep.indexOf('品質管理') > -1)) {
      this.isRecord = false
    }

    const day = this.data['day']

    // 稼働管理でクリックした日を初日とする（getHolidayDialogData の中で日の一覧を作るので、その前に入れておく）
    this.setInitDay()

    // 必要な情報取得
    this.getHolidayDialogData(day);

    // 有休残数
    this.paidHolidayLeft = await this.getPaidHolidaysLeft([]) + '日';
  }

  /**
   * 休みの開始日 変更時の処理
   * @param event 開始日
   */
  async changeStart(event) {
    this.start = event.value;
    if (this.start && this.end && this.start > this.end) {
      this.end = null
    }
    // 一覧を作り直してから長期か見る（待たないと、作り直す前の一覧で判定してしまう）
    await this.formatList()
    this.isReturnTask = this.isLongDays()
  }

  /**
   * 休みの終了日 変更時の処理
   * @param event 終了日
   */
  async changeEnd(event) {
    this.end = event.value;
    if (this.start && this.end && this.start > this.end) {
      this.start = null
    }
    // 一覧を作り直してから長期か見る（待たないと、作り直す前の一覧で判定してしまう）
    await this.formatList()
    this.isReturnTask = this.isLongDays()
  }

  /**
   * キャンセルボタン
   */
  cancel() {
    this.dialogRef.close();
  }

  /**
   * 登録ボタンイベント
   * 押したらすぐボタンを隠す（saving）。入力の確認で止まったときだけボタンを戻す
   * （前は有休残数の確認が返るまでボタンが出たままで、その間にもう一度押すと登録が2回走り、タスク・メール・有休の記録が2重になった）
   */
  async save() {
    if (this.saving) {
      return
    }
    this.saving = true
    let posted = false
    try {
      posted = await this.checkAndPost()
    } finally {
      // 登録の送信まで進まなかったときは、ボタンを戻す（送信したあとは、応答が返ったところで戻す）
      if (!posted) {
        this.saving = false
      }
    }
  }

  /**
   * 入力を確認して、問題なければ登録を送信する
   * @returns 送信したら true。確認で止まったら false
   */
  async checkAndPost(): Promise<boolean> {
    if (!this.list.length) {
      alert('登録するデータがありません。物件を選択してください。')
      return false
    }

    // 登録済みの振替の日（tar.disabled）は送らない。振替の登録・変更は振替ダイアログだけ
    // （送ると、種別はそのままでもメモ・有休時間が上書きされ、録音確認タスク・メールにもその日が混ざる）
    const saveList = this.sendList()

    let daysSelected = []
    // 有給登録する日
    const paidHolidayDays = {}

    for (let i = 0; i < saveList.length; i++) {
      const row = saveList[i]
      if (!row['target'] || !row['target'].length) {
        alert(row.nameSite + 'の休み登録する日がありません（登録済みの振替の日は登録しません）。日付を選択しなおすか、「' + row.nameSite + '」のチェックは外してください。')
        return false
      }
      for (let j = 0; j < row['target'].length; j++) {
        const tar = row['target'][j];
        if (!daysSelected.includes(tar.day)) {
          daysSelected.push(tar.day)
        }

        if (!tar.status && tar.status != 0) {
          alert(tar.day + 'の種別が選択されていません')
          return false
        }

        // 有休・指定有休・半有休の場合
        if ([1, 6, 8].includes(tar.status)) {
          // 有休時間チェック
          const h = tar.hours + '.' + tar.minutes
          if (!h || !Number(h) || isNaN(Number(h))) {
            alert(row.nameSite + '（' + tar.day + '）の有休時間が未完成です。')
            return false
          }
          tar.paidHolidayUsageTime = h

          // 有給
          let phDay = 1
          // 半有給
          if (tar.status == 8) {
            phDay = 0.5
          }
          if (paidHolidayDays[tar.day]) {
            // 半有給よりも有給が優先
            if (paidHolidayDays[tar.day] < phDay) {
              paidHolidayDays[tar.day] = phDay
            }
          } else {
            paidHolidayDays[tar.day] = phDay
          }

        // 短時間
        } else if (tar.status == 12) {
          const h = Number(tar.workingHours || 0)
          const set = Number(tar.hours + '.' + tar.minutes)

          if (!h || isNaN(h)) {
            alert(`${tar.day}は、もともと実働時間がないため、短時間は登録できません。\r\n種別を変更してください。`)
            return false
          }

          if (!set || isNaN(set)) {
            alert(`${tar.day} の実働時間が不正です`)
            return false
          }

          if (!tar.shortHorsMsg || tar.shortHorsMsg <= 0) {
            alert(`${tar.day} の実働時間が不正です`)
            return false
          }

          tar.shortHours = set
        }

        if (![1, 6, 8].includes(tar.status)) {
          tar.paidHolidayUsageTime = null
        }

        if (tar.status != 12) {
          tar.shortHours = null
        }
      }
    }
    // 日付順に並べ替え
    daysSelected.sort()

    // 有休・指定有休・半有休の場合、登録可能か確認
    if (Object.keys(paidHolidayDays).length) {
      const arr = Object.keys(paidHolidayDays)
      // 有休残数
      const left = await this.getPaidHolidaysLeft(arr);
      let val = 0

      for (let i = 0; i < arr.length; i++) {
        const key = arr[i]
        // 半有給なら+0.5、それ以外は1を足す
        val += paidHolidayDays[key]
      }

      if (left - val < 0) {
        alert('有休残数が足りないため、登録できません。');
        return false;
      }
    }

    if (!this.isReturnTask) {
      if (this.isLongDays()) {
        if (!window.confirm('復帰確認タスクは立てなくてよろしいでしょうか？')) {
          return false
        }
      }
    }

    // メモ用のテーブルに保存するデータを成型（送る日だけ）
    this.setOperationNote(saveList)

    const saveData = {
      // status: String(this.type),
      daysSelected,
      note: this.note,
      note2: this.note2,
      numberMobilePhone: this.value['numberMobilePhone'],
      numberPhone: this.value['numberPhone'],
      list: saveList,
      kana: this.value['kana']
    }
    // console.log(this.list)
    let staffName = this.value['name']
    if (this.data['staffDailyCleaning'] == '-1') {
      staffName = '欠員物件'
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-LoginAccessKey': localStorage.getItem('accessKey')
      })
    };

    // ここから先は送信。ボタンは save() が隠したままにしていて、応答が返ったところで戻す
    this.http.post(
      API_BASE_URL + '/api/v1/status?'
      + 'isRecord=' + this.isRecord
      + '&isReturnTask=' + this.isReturnTask
      + '&staffName=' + staffName
      + '&staffDailyCleaning=' + this.data['staffDailyCleaning']
      + '&userId=' + localStorage.getItem("uid")
      + '&isHoliday=' + true,
      { holiday: saveData, exchange: null },
      httpOptions
    ).subscribe(res => {
      // tbl_operation_noteに保存
      this.http.post(
        API_BASE_URL + '/api/v1/operationNote/save?days=' + daysSelected, this.operationNote, httpOptions
      ).subscribe(res => {
        this.saving = false;
        this.dialogRef.close(true);
      },error => {
        this.saving = false;
        alert("休みは登録しましたが、メモの保存でエラーになりました。稼働管理で確認してください。");
        this.dialogRef.close(true);
        return;
      });
    },error => {
      // 途中まで登録されていることがあるので、閉じて稼働管理を読み込み直す
      this.saving = false;
      alert(this.errorMessage(error, 'エラーのため、休み登録できませんでした。'));
      this.dialogRef.close(true);
      return;
    });

    return true
  }

  /**
   * サーバーから返ってきたエラーの文。無ければ決まった文を返す
   * @param error HTTP のエラー
   * @param fallback サーバーの文が無いときに出す文
   */
  errorMessage(error: any, fallback: string): string {
    const msg = error && error.error && error.error.message
    // 'No message available' は、サーバーが文を付けなかったときに入る決まり文句
    return (msg && typeof msg == 'string' && msg != 'No message available') ? msg : fallback
  }

  /**
   * 画面上部の表示データ取得
   */
  getHolidayDialogData(day: string) {
    this.nowLoading = true;

    this.http.get(API_BASE_URL + '/api/v1/status/getHolidayDialogData?cdSite=' + this.data['cdSite']
      + '&cdContract=' + this.data['cdContract']
      + '&cdStaff=' + this.data['staffDailyCleaning']
      + '&day=' + day
      + '&sequenceNumber=' + this.data['sequenceNumber'],
      {headers: this.headers})
      .subscribe(async (res) => {
        // 押した行の雇用指示が「その日に終わっていない雇用指示」の一覧に無い（作業終了・退職のあとの日に休みが残っている等）なら、
        // 休み登録はさせない（変な休みを登録されると困る。メモは稼働管理でカーソルを当てれば見える。ユーザー決定 2026-09-25）
        const siteList = res['siteList'] || []
        if (!siteList.some(s => s['sequenceNumber'] == this.data['sequenceNumber'])) {
          this.nowLoading = false;
          alert('この日は作業終了・退職などで雇用指示が終わっているため、休み登録はできません。');
          this.dialogRef.close();
          return;
        }

        // 清掃員の個人情報、担当物件情報
        this.siteList = siteList

        for (let i = 0; i < this.siteList.length; i++) {
          let s = this.siteList[i]
          s['check'] = false
          if (s['sequenceNumber'] == this.data['sequenceNumber']) {
            s['check'] = true
          }
        }

        await this.formatList()

        delete res['siteList']
        this.value = res;

        // 清掃員名は稼働管理のを入れる
        this.value['name'] = this.data['nameStaff']

        // 対象物件に代勤登録した人
        if (res && res['createdDate']) {
          this.operationCreatedDate = res['createdDate'];
          this.operationCreatedUser = res['createdUser'];
        }
        // すでに保存済みの休み登録情報（短時間の実働の表示は formatList が保存済みの状況ごとに出している）
        if (res && res['holiday']) {
          const h = res['holiday']
          this.note = h['note']
          this.note2 = h['note2']

          this.statusInsertedDate = moment(h.insertedDate).format('YYYY-MM-DD HH:mm')
          this.statusInsertedUser = h.insertedUser
          this.statusUpdateDate = moment(h.updateDate).format('YYYY-MM-DD HH:mm')
          this.statusUpdateUser = h.updateUser
        }
        this.nowLoading = false;
      },
      error => {
        this.nowLoading = false;
        // 認証エラーのときだけトップへ戻す。ほかのエラーはエラーと伝えてダイアログを閉じる
        if (error && (error.status == 401 || error.status == 403)) {
          alert("認証に失敗しました");
          this.router.navigate(['/']);
          return;
        }
        alert(this.errorMessage(error, 'エラーのため、休み登録の情報を取得できませんでした。'));
        this.dialogRef.close();
      }
    );
  }

  /**
   * 有休時間ドロップダウン作成
   * @param n 最大値
   * @returns　連番配列
   */
  generateNums(n: number): number[] {
    n++;
    return Array.from({length: n}, (x, i) => i);
  }

  /**
   * 雇用指示の実働時間取得
   * @param site チェックした物件リスト
   * @param days 対象日
   * @returns
   */
  async getWorkingHours(site: any[], days: any[]) {
    let ret = []
    if (!site || !days || !site.length || !days.length) {
      return null
    }

    for (let i = 0; i < site.length; i++) {
      const s = site[i]
      // 勤務形態、祝日を考慮した実働時間を取得
      const res = await this.getWorkingHoursBySite(s, days)
      ret = ret.concat(res)
    }

    return ret
  }

  /**
   * 対象物件の対象日の勤務時間などを取得
   * @param site 対象物件情報
   * @param days 対象日配列
   * @returns
   */
  async getWorkingHoursBySite(site, days) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-LoginAccessKey': localStorage.getItem('accessKey')
      })
    };
    let ret = []
    // 該当物件の該当日の実働時間・開始・終了を取得
    await this.http.post(
      API_BASE_URL + "/api/v1/instructEmployment/workingHours?&staffDailyCleaning="
      + this.data['staffDailyCleaning'],
      { site, days: [days[0], days[days.length - 1]] },
      httpOptions
    )
    .toPromise().then((res: any) => {
      ret = res
    })
    .catch((error: any) => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
    });

    return ret;
  }

  /**
   * 有休残数取得
   * @param day 除外したい日にち
   * @returns 残数
   */
  async getPaidHolidaysLeft(days) {
    let res = 0
    let targetDays = '';
    if (days && days.length) {
      targetDays = days.join('\',\'')
    }
    await this.http.get(API_BASE_URL + '/api/v1/paidHolidays/left?staffDailyCleaning=' + this.data['staffDailyCleaning']
      + '&targetDays=' + targetDays,
      {headers: this.headers})
      .toPromise().then((PaidHolidays: any) => {
        // 有休残日数
        if (PaidHolidays['intRes2'] && !isNaN(PaidHolidays['intRes2'])) {
          res = PaidHolidays['intRes2'];
        }
      })
      .catch((error: any) => {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
      });
    return res;
  }

  /**
   * 時間を時間と分に分割
   * @param time 時間
   * @returns
   */
  splitTime(time: String) {
    let t = [];
    if (time) {
      t = time.split('.');
    }
    var hours;
    var minutes;

    if(t.length > 0) {
      hours = Number(t[0]);
      if(t.length >= 2) {
        minutes = t[1];
        if (minutes == '50') {
          minutes = '5'
        }
      } else {
        minutes = '00';
      }
    } else {
      hours = 0;
      minutes = '00';
    }
    return { hours, minutes }
  }

  /**
   * 曜日を変更した際にする処理
   */
  async changeWeek() {
    // 一覧を作り直してから長期か見る（待たないと、作り直す前の一覧で判定してしまう）
    await this.formatList()
    this.isReturnTask = this.isLongDays()
  }

  /**
   * 休み種別を一括変更
   */
  setStatus() {
    this.list.forEach((l) => {
      l.target.forEach((t) => {
        // 登録済みの振替の日は変えない
        if (t.disabled) return
        this.changeStatus(t, this.status)
      })
    })
  }

  /**
   * 休み種別変更
   * @param tar 対象のデータ（tar.status は変更前の種別のまま渡す。ここで新しい種別を入れる）
   * @param status 新しい種別
   */
  changeStatus(tar, status) {
    const before = tar.status
    tar.status = status

    // 半有休にした：有休時間を実働時間の半分にする
    // 半有休からほかの種別に変えた：半分にした有休時間を実働時間に戻す（戻さないと、有休なのに半分の時間のまま登録される）
    if (tar.status == 8 || before == 8) {
      this.formatTime(tar.workingHours, tar)
    }
    this.getShort(tar)
  }

  /**
   * 時間変更
   * @param tar
   */
  changeTime(tar) {
    this.getShort(tar)
  }

  /**
   * 「複数日指定」のカレンダーマークをクリックした際にする処理
   * @param calendar
   */
  openCalendar(calendar: any) {
    // カレンダーを更新
    calendar.updateTodaysDate();
  }

  /**
   * 「複数日指定」選択した日に色を付ける
   * @param event 選択した日
   * @returns
   */
  isSelected = (event: any) => {
    const date = moment(event).format('YYYY-MM-DD');
    return this.daysSelected.find(x => x == date) ? 'selected' : null;
  }

  /**
   * 「複数日指定」選択した日を表示する
   * @param event 選択した日
   * @param calendar カレンダー
   */
  async select(event: any, calendar: any) {
    let date = moment(event).format('YYYY-MM-DD');
    const index = this.daysSelected.findIndex(x => x == date);
    if (index < 0) {
      this.daysSelected.push(date);
      this.days = this.daysSelected.join(", ");
    } else {
      // すでに選択済みの日をクリックした場合、配列から削除
      this.daysSelected.splice(index, 1);
      this.days = this.daysSelected.join(", ");
    }
    // 選択した日に色を付けるため、クリックするたびにカレンダーを更新
    calendar.updateTodaysDate();
    this.formatList()
  }

  /**
   * 画面表示ラジオボタンイベント
   */
  initialized() {
    // 稼働管理でクリックした日を初日とする
    this.setInitDay()
    // 複数日選択
    this.daysSelected = [];
    // 複数日選択（表示用）
    this.days = '';
    this.formatList()
  }

  /**
   * 開始日、終了日に稼働管理でクリックした日を反映
   */
  setInitDay() {
    // 稼働管理でクリックした日を初日とする
    this.start = new Date(this.data['day']);
    this.start.setHours(0);
    this.start.setMinutes(0);
    this.start.setSeconds(0);
    this.end = new Date();
    this.end.setTime(this.start.getTime());
  }

  /**
   * 登録で送る分（登録済みの振替の日を除いた list）。物件ごとに target を絞る。target が空になった物件は save が知らせて止める
   */
  sendList() {
    return this.list.map((row) => {
      return { ...row, target: (row.target || []).filter((t) => !t.disabled) }
    })
  }

  /**
   * 振替の種別名（登録済みの振替の日の表示用）
   * @param status 種別
   */
  exchangeName(status: any) {
    const name = HOLDAY_TYPE.find((h) => { return String(status) == String(h.key) })
    return name ? name.val : '振替'
  }

  /**
   * tbl_operation_note用のデータを生成
   * @param list 送る分（登録済みの振替の日を除いたもの）
   */
  setOperationNote (list: any[]) {
    this.operationNote = [];
    for (let idx = 0; idx < list.length; idx++) {
      const row = list[idx];

      for (let i = 0; i < row.target.length; i++) {
        const day = row.target[i].day
        const save = {
          operationNoteId: {
            sequenceNumber: row.sequenceNumber,
            staffDailyCleaning: this.data['staffDailyCleaning'],
            cdSite: row.cdSite,
            day,
          },
          cdContract: row.cdContract,
          note: this.note
        }
        this.operationNote.push(save);
      }
    }
  }

  /**
   * 契約勤務時間を表示
   * @param val
   * @returns
   */
  formatWorkTime(val) {
    if (val) {
      let res = val.replace('：', '')
      res = res.replace(/\(/g, '\r\n(')
      return res
    } else {
      return '-'
    }
  }

  /**
   * 物件リストチェックボックス変更
   */
  checkSite() {
    this.formatList()
  }

  /**
   * 物件リストクリック
   * @param row
   */
  clickSite(row) {
    row.check = !row.check
    this.formatList()
  }

  /**
   * 休み登録データを生成して、一覧（list）に入れる
   * 続けて呼ばれたときは、最後の呼び出しの結果だけを一覧に入れる。先の呼び出しは実働時間の取得を待ったあとで何もせずに終わる
   * （複数日指定・曜日指定はカレンダーやドロップダウンを開いたまま続けて選べる。前は遅く返ってきた古い結果で一覧が上書きされ、
   *   選んだ日が一覧から抜けたまま登録されることがあった）
   */
  async formatList() {
    // この呼び出しの番号
    const seq = ++this.formatSeq

    // 変更前のデータ
    const copied = JSON.parse(JSON.stringify(this.list));

    this.nowLoading = true
    let data = []
    const weekDays = ['日', '月', '火', '水', '木', '金', '土']

    // 対象物件リスト
    const site = this.siteList.filter((row) => {
      return row['check']
    })

    // 対象日リスト
    this.daysSelected = this.getDays()

    for (let i = 0; i < site.length; i++) {
      const s = site[i]
      const row = { sequenceNumber: s.sequenceNumber, cdSite: s.cdSite, cdContract: s.cdContract, nameSite: s.nameSite, target: [] }
      for (let j = 0; j < this.daysSelected.length; j++) {
        const day = this.daysSelected[j]
        // 曜日
        const week = weekDays[(new Date(day)).getDay()]
        row.target.push({ day, week, status: 0 })
      }
      data.push(row)
    }

    // 雇用指示の実働時間を取得
    const res = await this.getWorkingHours(site, this.daysSelected)

    // 待っている間に次の作り直しが始まっていたら、この結果は古いので捨てる（一覧もローディングも、最後の呼び出しが片付ける）
    if (seq != this.formatSeq) {
      return
    }

    if (res && res.length) {
      for (let i = 0; i < data.length; i++) {
        const row = data[i];
        for (let j = 0; j < res.length; j++) {
          const r = res[j];
          if (row.sequenceNumber == r.sequenceNumber && row.cdSite == r.cdSite && row.cdContract == r.cdContract) {
            for (let k = 0; k < row.target.length; k++) {
              const tar = row.target[k]
              if (tar.day == r.day) {
                  // もともとの実働時間
                  tar.workingHours = r.workingHours
                  // 開始時間
                  tar.start = r.start
                  // 終了時間
                  tar.end = r.end
                  // 時間と分に分割&半有休の考慮
                  this.formatTime(r.workingHours, tar)
                  // 祝日か否か（祝日の場合「祝日」文字列が入る）
                  tar.holiday = r.holiday
                  // 保存済みのステータス
                  if (r.status) {
                    tar.status = Number(r.status)
                    if (EXCHANGE_STATUS.includes(tar.status)) {
                      tar.disabled = true
                    }
                    if (r.paidHolidayUsageTime) {
                      tar.paidHolidayUsageTime = r.paidHolidayUsageTime
                      const ph = this.splitTime(r.paidHolidayUsageTime)
                      tar['hours'] = ph.hours
                      tar['minutes'] = ph.minutes
                    } else if (r.shortHours) {
                      tar.shortHours = r.shortHours
                      const ph = this.splitTime(r.shortHours)
                      tar['hours'] = ph.hours
                      tar['minutes'] = ph.minutes
                    }

                    // 短時間の実働時間
                    this.getShort(tar)
                  }
              }
            }
          }
        }
      }
    }

    // 変更前のデータを反映
    if (copied && copied.length) {
      for (let i = 0; i < copied.length; i++) {
        const c = copied[i];
        for (let j = 0; j < data.length; j++) {
          const row = data[j];
          // 同契約
          if (row.sequenceNumber == c.sequenceNumber) {
            for (let k = 0; k < c.target.length; k++) {
              const ct = c.target[k]
              for (let l = 0; l < row.target.length; l++) {
                const rt = row.target[l];

                // 同日
                if (ct.day == rt.day) {
                  rt.status = ct.status
                  rt.hours = ct.hours
                  rt.minutes = ct.minutes
                }
              }
            }
          }
        }
      }
    }

    // 勤務日のみの場合
    if (this.isOnlyWorkingDays && data.length) {
      this.setOnlyWorking(data)
    }

    this.list = data
    this.nowLoading = false
  }

  /**
   * 勤務日のみ変更イベント
   */
  async changeOnlyWorking() {
    // 勤務日のみ、に変更
    if (this.isOnlyWorkingDays && this.list && this.list.length) {
      this.setOnlyWorking(this.list)

    // 勤務日以外もすべて、に変更
    } else if (!this.isOnlyWorkingDays) {
      await this.formatList()
    }
  }

  /**
   * 勤務日のみ設定
   * @param data
   */
  setOnlyWorking(data) {
    for (let i = 0; i < data.length; i++) {
      const row = data[i]
      const onlyWorkday = []
      for (let j = 0; j < row.target.length; j++) {
        const tar = row.target[j]
        if (tar.workingHours && Number(tar.workingHours)) {
          onlyWorkday.push(tar)
        }
      }
      row.target = onlyWorkday
    }
  }

  /**
   * 対象日リスト生成
   */
  getDays() {
    let res = []
    // 開始日、終了日がある場合
    if (this.start && this.end && this.start <= this.end && ['consecutive', 'weekday'].includes(this.displaySpecifyDate)) {
      let startDay = moment(this.start);
      let endDay = moment(this.end);
      const daysDiff = endDay.diff(startDay, 'days');

      // 「連日」の場合
      if (this.displaySpecifyDate == 'consecutive') {

        for (let i = 0; i <= daysDiff; i++) {
          const day = moment(startDay).add(i, 'days').format('YYYY-MM-DD');
          res.push(day)
        }

      // 「曜日指定」の場合
      } else if (this.displaySpecifyDate == 'weekday') {

        for (let i = 0; i <= daysDiff; i++) {
          const day = moment(startDay).add(i, 'days').format('YYYY-MM-DD');
          const weekNumber = new Date(day).getDay();

          // 範囲指定の中に選択した曜日がある場合
          for (let j = 0; j < this.week.length; j++) {
            if (this.week[j] == weekNumber) {
              res.push(day)
            }
          }
        }
        res = res.sort()
      }
    }

    // 「複数日指定」の場合
    if (this.displaySpecifyDate == 'multiple' && this.daysSelected.length) {
      res = this.daysSelected.sort()
    }

    return res
  }

  /**
   * 実働時間を分割、半有休の場合は半分にする
   * @param time 実働時間
   * @param row 対象行
   */
  formatTime(time, row) {
    // 半有休の場合
    if (row.status == 8) {
      // 時間を半分にする
      time = Math.floor((Number(time) / 2) * 100) / 100;
    }
    // 時間と分に分割
    const res = this.splitTime(String(time))
    row.hours = res.hours
    row.minutes = res.minutes

    if (row.status == 8) {
      // 半有休の場合、デフォルトを実働時間の半分にしているため、切りの悪い「分」であれば空にする
      if (!this.minutes.includes(row.minutes)) {
        row.minutes = null
      }
    }
  }

  /**
   * 有休時間未入力の色設定
   * @param row
   * @returns
   */
  isEmpty(row) {
    if ((!row.hours && row.hours != 0) || !row.minutes) {
      return true
    }
    if (row.hours == 0 && row.minutes == '00') {
      return true
    }
  }

  /**
   * 設定なしの有休時間に一括設定
   */
  emptySet() {
    let flg = false
    for (let i = 0; i < this.list.length; i++) {
      const row = this.list[i]
      for (let j = 0; j < row.target.length; j++) {
        const tar = row.target[j]
        // 登録済みの振替の日は変えない
        if (tar.disabled) continue
        if (this.isEmpty(tar)) {
          tar.hours = this.setHours
          tar.minutes = this.setMinutes
          flg = true
        }
      }
    }
    if (!flg) {
      alert('有休時間が未設定になっている日はありませんでした。')
    }
  }

  /**
   * 長期の休みか確認。復帰確認タスクの初期値と、登録時の確認（「復帰確認タスクは立てなくてよろしいでしょうか？」）に使う
   * 目安の判定であって、厳密な決まりは無い（最後は登録する人が確認で決める）
   *   ・選んだ日の最初と最後の差が 7 以上（＝ 8 日分。連日 7 日は長期にならない）
   *   ・曜日指定・複数日指定で日が飛んでいても、最初と最後で見る（月曜だけ 3 週分でも長期になる）
   * 指定有休が1つでもあれば長期ではない扱い（指定有休は特別で、登録する人も限られている）
   * 登録済みの振替の日は登録しないので数えない
   * 日が1つも無いときも false を返す（何も返さないと isReturnTask が undefined になり、登録の API が 400 で落ちる）
   * @returns
   */
  isLongDays(): boolean {
    // 指定有休があれば、確認しない。登録済みの振替の日は登録しないので数えない
    const days: string[] = []
    for (let i = 0; i < this.list.length; i++) {
      const row = this.list[i];
      for (let j = 0; j < row.target.length; j++) {
        const tar = row.target[j];
        if (tar.disabled) continue
        if (tar.status == 6) {
          return false
        }
        if (!days.includes(tar.day)) days.push(tar.day)
      }
    }
    days.sort()
    if (days.length) {
      const st = moment(days[0] + ' 00:00:00')
      const en = moment(days[days.length - 1] + ' 00:00:00')

      const diff = en.diff(st, 'days')
      // 最初と最後の差が 7 以上（8 日分）なら長期。目安なのでこのまま
      return diff >= 7
    }
    return false
  }

  /**
   * 対象日を除外
   * @param i 物件のインデックス
   * @param j 対象日のインデックス
   */
  deleteDay(i, j) {
    this.list[i].target.splice(j, 1)
  }

  /**
   * 短時間の実働を表示
   * @param tar
   */
  getShort(tar) {
    if (tar.status === 12) {
      const h = Number(tar.workingHours || 0)
      const set = Number(tar.hours + '.' + tar.minutes)

      if (!h || isNaN(h)) {
        alert('もともと実働時間がないため、短時間は登録できません。\r\n種別を変更してください。')
        return
      }

      const diff = h - set
      if (!isNaN(diff)) {
        tar.shortHorsMsg = diff
      } else {
        tar.shortHorsMsg = null
      }
    } else {
      delete tar.shortHorsMsg
    }
  }
}
